import { api, LightningElement } from "lwc";

// eslint-disable-next-line local/no-set-access-token-resolver
import { setAccessTokenResolver } from "@devforce/trailhead-client-auth";
import { registerMiddleware } from "@devforce/trailhead-client-fetch";
import * as env from "@devforce/trailhead-client-env";
import { setLocale, Locale } from "@devforce/trailhead-client-locale";
import {
  setTrackingEnabled,
  setViewContext,
  setVisitorId,
} from "@devforce/trailhead-client-tracking";
import { ViewContextType } from "@devforce/trailhead-client-gql";
import { attrToBool } from "common/helpers";

export const DEFAULT_CLIENT_NAME = "Trailhead External";
let clientName = DEFAULT_CLIENT_NAME;

export const setClientName = (value: string) => (clientName = value);

registerMiddleware({
  name: "thexternal",
  handleRequest: async (request) => {
    if (!/\/graphql$/.test(request.url)) {
      return request;
    }

    const headers = {
      ...request.init.headers,
      "apollographql-client-name": clientName,
    };

    return {
      ...request,
      init: {
        ...request.init,
        headers,
      },
    };
  },
});

export default class extends LightningElement {
  @api
  get accessToken() {
    throw new Error("NOT_IMPLEMENTED");
  }
  set accessToken(value: string) {
    setAccessTokenResolver("thexternal/base", async () => {
      return value;
    });
  }

  /**
   * trailhead-client-fetch middlewares are global. This means the client name set on one component
   * will change the client name for all thexternal component instances on a given view.
   */
  @api
  get clientName() {
    throw new Error("NOT_IMPLEMENTED");
  }
  set clientName(value: string) {
    if (!value) return;
    setClientName(value);
  }

  @api
  get envApiHost() {
    throw new Error("NOT_IMPLEMENTED");
  }
  set envApiHost(value: env.Env["API_HOST"]) {
    env.set("API_HOST", value);
  }

  @api
  get envCommunityApiHost() {
    throw new Error("NOT_IMPLEMENTED");
  }
  set envCommunityApiHost(value: env.Env["COMMUNITY_API_HOST"]) {
    env.set("COMMUNITY_API_HOST", value);
  }

  @api
  get envExperienceApiHost() {
    throw new Error("NOT_IMPLEMENTED");
  }
  set envExperienceApiHost(value: env.Env["EXPERIENCE_API_HOST"]) {
    env.set("EXPERIENCE_API_HOST", value);
  }

  @api
  get locale() {
    throw new Error("NOT_IMPLEMENTED");
  }
  set locale(value: Locale) {
    setLocale(value);
  }

  @api
  get trackingDisabled() {
    throw new Error("NOT_IMPLEMENTED");
  }
  set trackingDisabled(value: string | boolean | null) {
    setTrackingEnabled(!attrToBool(value));
  }

  @api
  get trackingVisitorId() {
    throw new Error("NOT_IMPLEMENTED");
  }
  set trackingVisitorId(value: string) {
    setVisitorId(value);
  }

  @api
  trackingViewContext: ViewContextType | null = null;

  connectedCallback() {
    setViewContext(this.trackingViewContext);
  }
}
